import { WithDialog, XlDialogProps } from '@kinderlabs-pos/ui-atoms';
import { Box, Button, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import React from 'react';
import { FilterWith전체Selector } from '../../composites/FilterWithAllSelector';
import { PosFilterSelector } from '../../composites/PosFilterSelector';
import {
	OrderStatusTypeArray,
	OrderStatusTypeLabel,
	OrderType,
	OrderTypeArray,
	OrderTypeLabel,
} from '@kinderlabs-pos/shared-data-type';

export type OrderFilterType = {
	targetPosId?: number;
	status?: OrderType['status'];
	type?: OrderType['type'];
};
export interface IOrderFilterDialogProps extends XlDialogProps {
	filter: OrderFilterType;
	setFilter: React.Dispatch<React.SetStateAction<OrderFilterType>>;
}
export const OrderFilterDialog: React.FC<IOrderFilterDialogProps> = ({
	open,
	closeDialog,
	filter,
	setFilter,
}) => {
	const [tempFilter, setTempFilter] = React.useState(filter);

	return (
		<WithDialog.XlDialog
			scroll='paper'
			open={open}
			closeDialog={closeDialog}>
			<DialogTitle>주문 필터</DialogTitle>
			<DialogContent>
				<Stack
					direction={'row'}
					spacing={1}
					py={1}>
					<Box width={180}>
						<FilterWith전체Selector
							label={'주문 상태'}
							candidates={OrderStatusTypeArray.map((status) => ({
								label: OrderStatusTypeLabel[status],
								value: status,
							}))}
							value={tempFilter.status}
							onChangeValue={(value) => {
								// @ts-ignore // 아 select 들 type 짜증나...
								setTempFilter((prev) => ({ ...prev, status: value }));
							}}
						/>
					</Box>
					<Box width={180}>
						<FilterWith전체Selector
							label={'주문 타입'}
							candidates={OrderTypeArray.map((type) => ({
								label: OrderTypeLabel[type],
								value: type,
							}))}
							value={tempFilter.type}
							onChangeValue={(value) => {
								// @ts-ignore // 아 select 들 type 짜증나...
								setTempFilter((prev) => ({ ...prev, type: value }));
							}}
						/>
					</Box>
					<Box width={180}>
						<PosFilterSelector
							targetPosId={tempFilter.targetPosId}
							onChangeValue={(val) => {
								setTempFilter((state) => ({
									...state,
									targetPosId: val ? +val : undefined,
								}));
							}}
						/>
					</Box>
					{/* <Box width={180} my={1}>

          </Box> */}
				</Stack>
			</DialogContent>
			<DialogActions>
				<Button
					variant={'contained'}
					onClick={() => {
						setFilter(tempFilter);
						closeDialog && closeDialog();
					}}>
					확인
				</Button>
				<Button
					onClick={closeDialog}
					variant={'outlined'}>
					취소
				</Button>
			</DialogActions>
		</WithDialog.XlDialog>
	);
};
